import logoBestTransport from "@/assets/logos/best-transport.webp";
import logoDhl from "@/assets/logos/dhl.webp";
import logoTele2 from "@/assets/logos/tele2.webp";
import logoSecuritas from "@/assets/logos/securitas.webp";
import logoIca from "@/assets/logos/ica.webp";
import logoTibber from "@/assets/logos/tibber.webp";
import logoAssaAbloy from "@/assets/logos/assa-abloy.webp";
import logoBring from "@/assets/logos/bring.webp";
import logoAirmee from "@/assets/logos/airmee.webp";
import logoFoodora from "@/assets/logos/foodora.webp";
import logoDbSchenker from "@/assets/logos/db-schenker.webp";
import logoSveaSolar from "@/assets/logos/svea-solar.webp";
import logoElon from "@/assets/logos/elon.webp";
import logoAnticimex from "@/assets/logos/anticimex.webp";
import logoPlantagen from "@/assets/logos/plantagen.webp";
import logoDustin from "@/assets/logos/dustin.webp";

export interface CustomerLogo {
  name: string;
  src: string;
  segment?: "transport" | "service" | "ecommerce";
}

export const customerLogos: CustomerLogo[] = [
  { name: "Best Transport", src: logoBestTransport, segment: "transport" },
  { name: "DHL", src: logoDhl, segment: "transport" },
  { name: "DB Schenker", src: logoDbSchenker, segment: "transport" },
  { name: "Bring", src: logoBring, segment: "transport" },
  { name: "Airmee", src: logoAirmee, segment: "transport" },
  { name: "Foodora", src: logoFoodora, segment: "ecommerce" },
  { name: "ICA", src: logoIca, segment: "ecommerce" },
  { name: "Tele2", src: logoTele2, segment: "service" },
  { name: "Tibber", src: logoTibber, segment: "service" },
  { name: "Securitas", src: logoSecuritas, segment: "service" },
  { name: "Assa Abloy", src: logoAssaAbloy, segment: "service" },
  { name: "Svea Solar", src: logoSveaSolar, segment: "service" },
  { name: "Elon", src: logoElon, segment: "ecommerce" },
  { name: "Anticimex", src: logoAnticimex, segment: "service" },
  { name: "Plantagen", src: logoPlantagen, segment: "ecommerce" },
  { name: "Dustin", src: logoDustin, segment: "ecommerce" },
];
